<template lang="pug">
.email-notification.col-sm-10.col-md-10
    .row-col
        .padding
            .alert.info
                i.material-icons.md-24.m-r-sm &#xe88f;
                | Manage email addresses that will receive daily sales notifications.
            .box
                v-server-table(
                    ref="datatable",
                    :url="url",
                    name="EMAIL_NOTIFICATION",
                    :columns="columns",
                    :options="options"
                )

        email-form(ref="emailForm")
</template>

<script>
import Auth from '@js/plugins/auth';
import emailForm from './email-notification-form.vue';
import event from './email-notification-event';

export default {
    components: {
        emailForm,
    },

    data() {
        let canManageSettings = Auth.hasPermissionTo(
            'franchise_manage_settings',
        );

        let actionButtons = [
            {
                title: 'Add Email',
                action: () => {
                    this.showEmailForm();
                },
            },
        ];

        if (!canManageSettings) {
            actionButtons = [];
        }

        return {
            columns: ['email', 'created_at'],
            options: {
                checkbox: canManageSettings,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.setting.email_notification.delete',
                    ),
                    delete_title: 'Delete Email',
                },
                actionButtons: actionButtons,
                rowClickCallback: row =>
                    this.$refs.emailForm.$emit('show', row),
                rowClassCallback: row => 'pointer',
                sortable: ['email', 'created_at'],
                dateColumns: ['created_at'],
            },
        };
    },

    computed: {
        url() {
            return Laroute.route('franchise.setting.email_notification.index');
        },
    },

    mounted() {
        event.$on('email-created', () => {
            this.$refs.datatable.getData();
        });

        event.$on('email-updated', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        showEmailForm() {
            this.$refs.emailForm.$emit('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/email-notification/email-notification.vue